import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button } from 'palette/Button';
import { useFavoritesBrands } from '../hooks/useFavouritesBrands';
import '../styles/FavoritesBrandButton.scss';

export function FavoritesBrandButton({
    brandAzId,
    brandId,
    brandGender,
    brandName,
    className,
    size = 'medium',
    noPaddingLeft = false,
    hasToMarkAsFovoriteOnNextRender = false // workaround to fix issue when server side data doesnt match client side
}) {
    const { isFavorite, addToFavorites, removeFromFavorites } = useFavoritesBrands();

    const isBrandFavorite = isFavorite(brandGender, brandAzId);
    const [isMarkedAsFavorite, setIsMarkedAsFavorite] = useState(hasToMarkAsFovoriteOnNextRender ? false : isBrandFavorite);
    const iconName = isMarkedAsFavorite ? 'palette_heart_full' : 'palette_heart';
    const iconColor = isMarkedAsFavorite ? 'red-800' : 'black';

    const handleClick = (event) => {
        event.stopPropagation();

        if (isMarkedAsFavorite) {
            removeFromFavorites(brandId, brandGender, brandName, brandAzId);
        } else {
            addToFavorites(brandId, brandGender, brandName, brandAzId);
        }
    };

    useEffect(() => {
        setIsMarkedAsFavorite(isBrandFavorite);
    }, [isBrandFavorite]);

    return (
        <Button
            isTransparent
            className={classNames('favorites-brand-button', className, { 'favorites-brand-button--flush-left': noPaddingLeft })}
            iconColor={iconColor}
            iconName={iconName}
            size={size}
            theme="secondary"
            onClick={handleClick}
        />
    );
}

FavoritesBrandButton.propTypes = {
    brandId: PropTypes.string.isRequired,
    brandGender: PropTypes.string.isRequired,
    brandName: PropTypes.string.isRequired
};
